import { render } from "./q1.vue?vue&type=template&id=40fdfd9c&scoped=true"
import script from "./q1.vue?vue&type=script&lang=js"
export * from "./q1.vue?vue&type=script&lang=js"

import "./q1.vue?vue&type=style&index=0&id=40fdfd9c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40fdfd9c"],['__file',"cartridges/int_guidedProductFinder/cartridge/client/default/js/components/questionTemplates/q1.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "40fdfd9c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('40fdfd9c', __exports__)) {
    api.reload('40fdfd9c', __exports__)
  }
  
  module.hot.accept("./q1.vue?vue&type=template&id=40fdfd9c&scoped=true", () => {
    api.rerender('40fdfd9c', render)
  })

}


export default __exports__